export default __webpack_public_path__ + "static/media/1619430076986.60b8ef41.jpg";